import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getMonthlyRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";

import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_DATES,
  FETCH_CHART_SUCCESS,
  SET_UPDATES_LOADING,
  RESET_FILTER_SELECTED,
  UPDATE_CUSTOM_RANGE,
  UPDATE_FILTERS,
  REFETCH_FILTERS_SUCCESS,
  SET_DYNAMIC_FILTERS_STATUS,
  RESET_DYNAMIC_FILTERS_STATUS,
  SET_FIRST_EDITED_DYNAMIC_FILTER,
  UPDATE_TABLE_VIEW
} from "./classCountSagas";

const dynamicFilters = ["staff", "class"];

const initialState = {
  currentUser: {},
  initialRequest: false,
  isLoading: true,
  chartData: {},
  dataPoints: [],
  updatesLoading: false,
  filtersDirty: false,
  selectedRequestDates: {},
  filters: {},
  pendingFilters: [],
  firstEditedDynamicFilter: "",
  selectedFilters: {
    table_view: false,
    staff: [],
    class: []
  },
  rangeOptions: [],
  selectedRangeOption: {}
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [SET_FIRST_EDITED_DYNAMIC_FILTER]: (state, action) => ({
      ...state,
      firstEditedDynamicFilter: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => {
      let rangeOptions = getMonthlyRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.calendarStartDate
      );

      return {
        ...state,
        selectedRequestDates: action.payload,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload
      }
    }),
    [REFETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      firstEditedDynamicFilter: "",
      filters: { ...state.filters, ...action.payload },
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload
      }
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload.chart,
      dataPoints: action.payload.dataPoints
    }),
    [UPDATE_TABLE_VIEW]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [UPDATE_FILTERS]: (state, { payload: { data, key } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, [key]: data }
    }),
    [SET_DYNAMIC_FILTERS_STATUS]: (state, { payload }) => ({
      ...state,
      pendingFilters: payload
        ? dynamicFilters.filter((filterName) => filterName !== payload)
        : dynamicFilters
    }),
    [RESET_DYNAMIC_FILTERS_STATUS]: (state) => ({
      ...state,
      pendingFilters: []
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedRequestDates: action.payload,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      )
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      pendingFilters: [],
      firstEditedDynamicFilter: "",
      selectedFilters: { ...initialState.selectedFilters }
    })
  },
  initialState
);
